export default __webpack_public_path__ + "static/media/Futura-Medium.36bbce08.ttf";